var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar p-shadow-9"},[_c('div',{staticClass:"f-softscroll darker",staticStyle:{"display":"flex","flex-direction":"column","align-items":"stretch","height":"100%","width":"100%"}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }